import { SerializedError } from "@reduxjs/toolkit"
import { FetchArgs, FetchBaseQueryMeta } from "@reduxjs/toolkit/dist/query/fetchBaseQuery"
import { BaseQueryFn, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { translate } from "src/i18n/tHelper"
import { RootState } from "src/store"
import AuthSlice from "src/store/Slices/Base/AuthSlice"
import SnackbarUtils from "src/utils/SnackbarUtils"
import { ApiResponse } from "./ApiService"
import { env } from "src/env"


const baseQuery = fetchBaseQuery({
  //baseUrl: "/api/api/v1", //api/api/v1 Frontend ve backend aynı porttaysa kullanılır
  baseUrl: env.REACT_APP_WEP_API_URL
})
class apiResponse<T> extends ApiResponse<T> {
  constructor() {
    super();
    this.errorMessages = [];
  }
  errorMessages: Array<string>;
}
interface IFetchArgs extends FetchArgs {
  method?: "GET" | "PUT" | "DELETE" | "POST"
}
const customBaseQuery: BaseQueryFn<
  IFetchArgs,
  any,
  any,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  let headers = {
    ...args.headers,
    "Accept": "application/json",
    "Access-Control-Allow-Credentials": "true",
    "X-Requested-With": "XMLHttpRequest",

  }
  const token = (api.getState() as RootState).userLogin?.userInfo?.accessToken
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  if (!(args.body instanceof FormData)) {
    headers["Content-Type"] = "application/json; charset=utf-8";
  }
  args.headers = {
    ...headers
  }
  //before
  let result = await baseQuery(args, api, extraOptions)
  //after
  if (result.error && result.error.status === 401) {
    api.dispatch(AuthSlice.actions.logOut())
    return;
  }
  if (result.meta && result.meta.response?.status > 401 && result.meta.response?.status < 500) {
    let error = result.meta.response.url + " " + result.meta.response.statusText;
    (result.error as SerializedError) = {
      message: error,
      name: "API_ERROR",
    }
    return result;
  }
  const data = result.data as apiResponse<any>;
  if (result.error) {
    (result.error as SerializedError) = {
      message: result.error["error"] || result.error["message"],
      name: "API_ERROR",
    }
  } else if (data?.errorMessages?.length > 0) {
    (result.error as SerializedError) = {
      code: data.responseCode?.toString(),
      message: data.errorMessages[0],
      name: "BUSINESS_ERROR",
    }
  }
  else {
    if (api.type === "mutation") {
      // if (args.method === "POST")
      //     SnackbarUtils.success(translate("common", "Kayıt Başarıyla Eklendi"))
      if (args.method === "PUT")
        SnackbarUtils.success(translate("common", "Kayıt Başarıyla Güncellendi"))
      if (args.method === "DELETE")
        SnackbarUtils.success(translate("common", "Kayıt Başarıyla Silindi"))
    }
  }
  if (data?.version !== process.env.REACT_APP_VERSION && data?.version) {
    window.location.href = "/logout"
  }
  if (data.data && JSON.stringify(data.data))
    result.data = data.data;
  return result;
}

export const api = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'api',
  endpoints: builder => ({}),
  tagTypes: ["User",
    "BransTanim",
    "OrganizasyonKullanici",
    "Verikontrol",
    "MenuAuth",
    "ControlAuth",
    "Parameters",
    "LanguageParameters",
    "FaturaKurumIcmalHazirla",
    "FaturaKurumIcmalSorgula",
    "FaturaKurumIcmalDetay",
    "DrHakedisSorgu",
    "DrHakedisList",
    "VwHastamuracaatListe",
    "KullaniciVarsayilan",
    "KullaniciPrinter",
    "PcInfo",
    "KullaniciEkranrapor",
    "RoldbServistanim",
    "ServisVeri",
    "HastaMuayene",
    "HbsRaportiptanim",
    "Raportipislem",
    "Islemtanim",
    "HastaRaporlama",
    "RolDbKullanici",
    "TeleDiagnosisTanim",
    "KararDestekGrup",
    "KararDestekSorguSart",
    "KurumTanim",
    "UcretTarifeTanim",
    "KurumTarife",
    "UcretTarife",
    "KurumTarifeIstisna",
    "OrganizasyonOdemeTipListe",
    "OrganizasyonTanim",
    "Locales",
    "IslemtanimRapor",
    "HastaDosyalari",
    "HastaDetayDosyalari",
    "VAlisSonuc",
    "Tani",
    "HastaMuayeneKimlik",
    'YatisTalep',
    'ServisProtokol1',
    'ServisProtokol2',
    "ParametreTanim",
    "ParametreTanimDetay",
    "Konsultasyon",
    "VwHbsOrderListefind",
    "OrderPatolojiDetay",
    "OrderAmeliyatDetay",
    "YatakTanim",
    "YatakGrupTanim",
    "PatolojiNumuneKabulListe",
    "KargoKuryeTakip1",
    "KargoKuryeTakip2",
    "HastaRaporDetay",
    "PatolojiLaboratuvarListesi",
    "KimlikGuncelle",
    "PatolojiLabSurecBilgileri",
    "PatolojiLabImzaBilgileri",
    "RaporTipTanimVeriGiris",
    "OrderPatolojiIstekler",
    "PatolojiRaporIslemleriListe",
    "PatolojiArsivDepoListesi",
    "PatolojiArsivDepoTanimListesi",
    "HesapPlanTanim",
    "OrderPatoloji",
    "NumuneKabulBekleyenTalepler",
    "PatolojiBekleyenTalepSayac",
    "PatolojiArsivHareketleri",
    "MbsMuhasebeIslem",
    "MbsMuhasebeIslemDetay",
    "RaporSablonListesi",
    "RaporSablonDetayListesi",
    "PatolojiLabEkIslemler",
    "HastaMuracaatIzlem",
    "VAlisKulturWs",
    "VAlisSonucDosyaWs",
    "TestDetayBilgi",
    "GnlKurumGrup",
    "FaturaKurumIcmalHazirlaTetkiklerListe",
    "FaturaKurumIcmalHazirlaHastaListe",
    "FaturaKurumIcmalHazirlaHastaTetkiklerListe",
    "FaturaKurumIcmalSorgulaTetkiklerListe",
    "FaturaKurumIcmalSorgulaHastaListe",
    "FaturaKurumIcmalSorgulaHastaTetkiklerListe",
    "NlpSearch",
    "HastaRaporSonuclariHastaListesi",
    "HastaRaporSonuclariDetayListesi",
    "DepoTalepList",
    "DepoTalepDetayList",
    "RadyolojiCekim",
    "RadyolojiKabul",
    "SablonAktarIslemListesi",
    "KullaniciList",
    "KullaniciVtysList",
    "KurumEntEklenenIslemler",
    "MesajOkumaBilgi",
    "MesajListesi",
    "MesajModulOkumaBilgi",
    "MesajModulListesi",
    "MesajOkundu",
    "StkOrderTalep",
    "StkOrderTalepIlac",
    "DovizKur",
    "SonucIzlemeMuracaatListesi",
    "ServisTanim",
    "HastaTani",
    "SikKullanilanListesi",
    "ArsivTanimListesi",
    "KullaniciTanimListesi",
    "KimlikBilgisi",
    "PersonelBilgisi",
    "KullaniciBilgisi",
    "KullaniciOrganizasyonListesi",
    "KullaniciRolYetkiListesi",
    "RolTanimYetkiListesi",
    "RolTanimYetkiVtysListesi",
    "RolTanimYetkiRaporListesi",
    "KullaniciTanimVezneListesi",
    "KullaniciTanimKullaniciVtysListesi",
    "KullaniciTanimServisYetkiListesi",
    "KullaniciTanimTarifeIptalListesi",
    "IstemPanelGrup",
    "IstemPanelIslem",
    "OrganizasyonEntegrasyon",
    "HbsRaporsablonicd",
    "PatolojiRaporKurtarListesi",
    "TestIstemDetayBilgi",
    "DepoStok",
    "KullaniciDepo",
    "HastalikTanim",
    "HastalikTanimIslem",
    "ServisTanimUcretListesi",
    "ServisYatakTanim",
    "ServisYatak",
    "DepoDonem",
    "OrderListe",
    "TedaviUygulamaListesi",
    "RaporPersonel",
    "StkOrderTalepHasta",
    "IlacUygulama",
    "IlacUygulamaHastaListe",
    "RezervBarkod",
    "KurumBonusTanimlari",
    "KurumBonusTanimlariDetay",
    "KurumBonusTanimlariDetayTestVeri",
    "YetkiTanim",
    "KurumMailGonderimAyarlari",
    "HastaUyari2Listesi",
    "SonucIzlemeTanimlari",
    "RedPanikSayac",
  ], //neleri cache leyeceğim ?

})
export default api;
